import React, { forwardRef, memo } from 'react'

const OfferConditionsShape = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="396.2"
    height="277.9"
    viewBox="0 0 566 397"
    fill="none"
    {...props}>
    <path
      d="M122 198.343C122 88.8013 210.801 0 320.343 0H660.063V396.687H320.343C210.801 396.687 122 307.885 122 198.343Z"
      fill="#EFF7E4"
    />
    <circle
      cx="264.617"
      cy="112.747"
      r="57.9072"
      transform="rotate(23.1103 264.617 112.747)"
      fill="#D15A19"
    />
    <mask
      id="mask0_308_2"
      maskUnits="userSpaceOnUse"
      x="206"
      y="54"
      width="117"
      height="117">
      <circle
        cx="264.617"
        cy="112.747"
        r="57.9072"
        transform="rotate(23.1103 264.617 112.747)"
        fill="#C27C00"
      />
    </mask>
    <g mask="url(#mask0_308_2)" stroke="white" strokeWidth="2.544">
      <path d="M226.781 66.8379L250.183 76.8244" />
      <path d="M206.496 127.338L229.897 137.324" />
      <path d="M202.099 92.2656L231.351 104.749" />
    </g>
    <ellipse
      cx="274.301"
      cy="117.545"
      rx="53.4307"
      ry="58.5193"
      transform="rotate(23.1103 274.301 117.545)"
      fill="#FFA300"
    />
    <circle
      cx="119.289"
      cy="129.711"
      r="57.9072"
      transform="rotate(8.50468 119.289 129.711)"
      fill="#D15A19"
    />
    <mask
      id="mask1_308_2"
      maskUnits="userSpaceOnUse"
      x="61"
      y="71"
      width="117"
      height="117">
      <circle
        cx="119.289"
        cy="129.711"
        r="57.9072"
        transform="rotate(8.50468 119.289 129.711)"
        fill="#C27C00"
      />
    </mask>
    <g mask="url(#mask1_308_2)" stroke="white" strokeWidth="2.544">
      <path d="M71.0981 94.8262L96.2615 98.589" />
      <path d="M66.7256 158.486L91.889 162.249" />
      <path d="M53.6265 125.656L85.0807 130.36" />
    </g>
    <ellipse
      cx="129.869"
      cy="131.914"
      rx="53.4307"
      ry="58.5193"
      transform="rotate(8.50468 129.869 131.914)"
      fill="#FFA300"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.8317 111.631C30.4311 111.096 26.4299 114.229 25.8947 118.63L0.967428 323.59C0.432233 327.99 3.56569 331.992 7.96623 332.527L326.504 371.268C330.905 371.803 334.906 368.669 335.441 364.269L342.521 306.057L310.774 302.196C286.325 299.223 268.916 276.992 271.889 252.544C274.863 228.095 297.093 210.685 321.542 213.659L353.289 217.52L360.368 159.309C360.904 154.908 357.77 150.907 353.37 150.372L34.8317 111.631Z"
      fill="#78BE20"
    />
    <path
      d="M281.095 254.117C283.437 234.854 300.952 221.137 320.215 223.48L374.463 230.078C376.113 230.279 377.288 231.779 377.087 233.429L369.33 297.21C369.13 298.86 367.629 300.035 365.979 299.834L311.731 293.237C292.468 290.894 278.752 273.379 281.095 254.117Z"
      fill="#78BE20"
    />
    <circle
      cx="320.455"
      cy="258.451"
      r="14.8649"
      transform="rotate(6.93427 320.455 258.451)"
      fill="#CEDC00"
    />
  </svg>
))

OfferConditionsShape.displayName = 'OfferConditionsShape'

export default memo(OfferConditionsShape)
